import { render } from "./Workouts.vue?vue&type=template&id=42d00a88&scoped=true"
import script from "./Workouts.vue?vue&type=script&lang=js"
export * from "./Workouts.vue?vue&type=script&lang=js"

import "./Workouts.vue?vue&type=style&index=0&id=42d00a88&scoped=true&lang=scss"

import exportComponent from "/Users/lolo/projects/mygpsworkouts-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d00a88"]])

export default __exports__